import type { ReactNode } from 'react';

export const symbol_1x_mobiledata: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M242-620h-52q-13 0-21.5-8.5T160-650q0-13 8.5-21.5T190-680h82q13 0 21.5 8.5T302-650v340q0 13-8.5 21.5T272-280q-13 0-21.5-8.5T242-310v-310Zm358 184-84 141q-4 7-11 11t-15 4q-17 0-26-15t0-30l100-168-86-142q-9-15-.5-30t26.5-15q8 0 15 3.5t11 10.5l70 116 66-115q4-7 11-11t15-4q17 0 26 15t0 30l-82 142 98 168q9 15 0 30t-26 15q-8 0-15-4t-11-11l-82-141Z"
		/>
	</svg>
);
